import { Key, ReactNode } from "react"
import { FlexGrid, FlexGridItem } from "@mezo-org/mezo-clay"

export default function LeaderboardStatsWrapper({
  stats,
}: {
  stats: { children: ReactNode; key: Key }[]
}) {
  return (
    <FlexGrid
      flexGridColumnCount={[1, 1, 1, 3]}
      flexGridColumnGap="scale900"
      flexGridRowGap="scale900"
      marginBottom="scale1600"
      marginTop="scale600"
    >
      {stats.map(({ children, key }) =>
        children ? <FlexGridItem key={key}>{children}</FlexGridItem> : null,
      )}
    </FlexGrid>
  )
}
